import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-dialog-checks',
  templateUrl: './dialog-checks.component.html',
  styleUrls: ['./dialog-checks.component.css']
})
export class DialogChecksComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
